import firebase from 'firebase/app'

const { hostname } = window.location

window.usingDevelopmentServer =
  hostname !== 'editor.boardsapp.com' && hostname !== 'bliss-editor.web.app'
window.contentServer = window.usingDevelopmentServer
  ? 'bliss-development.appspot.com'
  : 'bliss-creator.appspot.com'

const configDevelopment = {
  apiKey: 'AIzaSyDTliOKFp0-8sCKyvcN-B-3VMJyKnVsetU',
  authDomain: 'bliss-development.firebaseapp.com',
  databaseURL: 'https://bliss-development.firebaseio.com',
  projectId: 'bliss-development',
  storageBucket: 'bliss-development.appspot.com',
  messagingSenderId: '754174199678',
  appId: '1:754174199678:web:7f0bbced6c0c87a782552f',
  measurementId: 'G-TGX6EBL7JH',
}

const configProduction = {
  apiKey: 'AIzaSyB8Ngiarho_IkfX2O20SA7G00wx5UZlH70',
  authDomain: 'bliss-creator.firebaseapp.com',
  databaseURL: 'https://bliss-creator.firebaseio.com',
  projectId: 'bliss-creator',
  storageBucket: 'bliss-creator.appspot.com',
  messagingSenderId: '266172157938',
  appId: '1:266172157938:web:2b0a93d92744a293e0256b',
  measurementId: 'G-DDV9E4CYEV',
}

const config = window.usingDevelopmentServer
  ? configDevelopment
  : configProduction

let Firebase = firebase.initializeApp(config)

export default Firebase
